import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import StationInvoiceContainer from '../containers/accounting/StationInvoice';
import FMPHeadline from "../components/ui/FMPHeadline";

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
		textAlign : 'left',
		boxSizing: 'border-box',
		padding : 25,
		paddingBottom : 30,
		[theme.breakpoints.up('md')]: {
			padding : '40px 40px 40px 40px',
		}
	},
	productRow : {
		display : 'flex',
		flexDirection : 'row',
		padding : 20,
	},
	lineItem : {
		display : 'flex',
		flexDirection : 'row',
		justifyContent : 'space-between',
		lineHeight : 1.3,
	},
	lineItemHeader : {
		display : 'flex',
		flexDirection : 'row',
		justifyContent : 'space-between',
		fontSize : 15,
		textTransform : 'upperCase',
	},
	header : {
		display : 'flex',
		flexDirection : 'column',
		fontSize : 20,
		fontWeight : 200,
	},
	row : {
		borderBottom : '1px solid #ddd',
		paddingTop : 5,
		paddingBottom : 10,
		marginBottom : 10,
	},
	headerRow : {
		borderBottom : '1px solid #ddd',
		paddingBottom : 2,
		marginBottom : 2,
	},
	quickbooksId : {
		paddingRight : 10,
		fontWeight : 200,
		color : '#999',
	},
	note : {
		padding : 20,
		border : '1px solid #ddd',
		backgroundColor : "#f2f2f2",
		marginBottom : 30,
		lineHeight : 1.5,
	},
});



//- What do I want to see here


class ProductMatrix extends Component {

	constructor (props) {
		super(props);
		this.state = {
			gallonsAvailableFromAlltech : 8150,
		};
	}

	componentDidMount() {

		const { showErrors, getProductInvoiceMatrix} = this.props;

		getProductInvoiceMatrix({
			callback : (err, results) => {
				if (err) {
					showErrors(err);
					return;
				}
				const { products } = results;
				this.setState({ products });
			}
		});
	}

	render() {
		const { classes } = this.props;

		const { products } = this.state;

		if (_.isEmpty(products)) {
			return (<div>Fetching products...</div>);
		}

		return (<Grid container spacing={3}>
			<Grid item xs={12}>

				<FMPHeadline label={'Product to Invoice Matrix'} />
				<Paper className={classes.paper}>

					<div className={classes.note}>
						<strong>Notes</strong><br/>
						<ul>
							<li>
								<strong>* New 8/8/2020 *</strong>New Station invoices for deliveries that use the old
								or new H&S Formulas will have an additional invoice line item for Freight.
							</li>

							<li>
								Station invoices for deliveries that use the Falcon or 29Palms E85 Formula
								will have an additional invoice line item for Freight.
							</li>


							<li>
								Credits for station invoices for deliveries that use the
								Falcon or 29Palms E85 Formula will be credited as a Freight Credit (QBID #769) NOT
								the fuel credit line item displayed in this chart
							</li>
							<li>
								Fuel prices in this table use a dummy price of $2.77 for the unit cost
							</li>
							<li>
								E85 and Ethanol (ETOH) use their description from Quickbooks where the other fuels are
								generated from the name of the fuel.
							</li>

						</ul>
					</div>

					<Grid container spacing={3} className={classes.headerRow}>
						<Grid item xs={12} sm={3} className={classes.header}>
							Fuel
						</Grid>
						<Grid item xs={12} sm={4} className={classes.header}>
							<div style={{paddingBottom : 10}}>Fuel Invoice Line Items</div>

							<div className={classes.lineItemHeader}>
								<div>Description</div>
								<div>Unit Cost</div>
							</div>

						</Grid>
						<Grid item xs={12} sm={4} className={classes.header}>
							<div style={{paddingBottom : 10}}>Credit Invoice Line Items</div>

							<div className={classes.lineItemHeader}>
								<div>Description</div>
								<div>Unit Cost</div>
							</div>

						</Grid>
					</Grid>

					{products.map(product => {
						const { display, productType, fuelLineItems, creditLineItem} = product;
						return (
							<Grid key={productType} container spacing={3} className={classes.row}>
								<Grid item xs={12} sm={3}>
									{display}
								</Grid>
								<Grid item xs={12} sm={4}>
									{fuelLineItems.map(lineItem => {
										const { Description, quickbooksItemId, UnitPrice } = lineItem;
										return (<div key={quickbooksItemId} className={classes.lineItem}>
											<div>
												<span className={classes.quickbooksId}>({quickbooksItemId})</span>
												{Description}
											</div>
											<div>
												{UnitPrice}
											</div>
										</div>);
									})}
								</Grid>
								<Grid item xs={12} sm={4}>
									{[creditLineItem].map(lineItem => {
										const { Description, quickbooksItemId, UnitPrice } = lineItem;
										return (<div key={quickbooksItemId} className={classes.lineItem}>
											<div>
												<span className={classes.quickbooksId}>({quickbooksItemId})</span>
												{Description}
											</div>
											<div>
												{UnitPrice}
											</div>
										</div>);
									})}
								</Grid>
							</Grid>
						);
					})}
				</Paper>
			</Grid>
		</Grid>);
	}
}

ProductMatrix.propTypes = {
	classes: PropTypes.object.isRequired,
	getProductInvoiceMatrix: PropTypes.func.isRequired,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	StationInvoiceContainer,
])(ProductMatrix);
